export const formEmptyDefault = () => ({
  codigo: null,
  nome: "",
  concedente_id: "",
  prazo: null,
  disponibilidade: null,
  categorias: null,

  created_start: "",
  created_end: "",
  update_start: "",
  update_end: "",
  available_start: "",
  available_end: "",
  proposta_ini_start: "",
  proposta_ini_end: "",
  proposta_fim_start: "",
  proposta_fim_end: "",

  natureza_juridica: null,
  areas: [],
  tipo_instrumento: "",
  qualificacao_proposta: "",
  valor_projeto_min: null,
  valor_total_min: null,
  moeda_id: null,
  estado: [],
  nacionalidade: [],
  municipio: [],
  ods: [],
  status: null,
});

export const filterGroups = {
  periods: [
    "created_start",
    "created_end",
    "update_start",
    "update_end",
    "available_start",
    "available_end",
    "proposta_ini_start",
    "proposta_ini_end",
    "proposta_fim_start",
    "proposta_fim_end",
  ],
  classification: ["natureza_juridica", "qualificacao_proposta", "areas"],
  location: ["estado", "municipio", "nacionalidade"],
  values: ["valor_projeto_min", "valor_total_min", "moeda_id"],
  ods: ["ods"],
  all: [
    "codigo",
    "nome",
    "concedente_id",
    "prazo",
    "disponibilidade",
    "categoria",
    "created_start",
    "created_end",
    "update_start",
    "update_end",
    "available_start",
    "available_end",
    "proposta_ini_start",
    "proposta_ini_end",
    "proposta_fim_start",
    "proposta_fim_end",
    "natureza_juridica",
    "areas",
    "tipo_instrumento",
    "qualificacao_proposta",
    "valor_projeto_min",
    "valor_total_min",
    "moeda_id",
    "estado",
    "nacionalidade",
    "municipio",
    "ods",
    "status",
  ],
};
